import { motion } from 'framer-motion';
import {
  useState,
  type ChangeEvent as ReactChangeEvent,
  type MouseEvent as ReactMouseEvent,
} from 'react';

import EyeIcon from '../../images/icons/EyeIcon';
import EyeOffIcon from '../../images/icons/EyeOffIcon';

interface IInputPasswordProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'onChange'> {
  dataCy?: string;
  onChange?: (event: ReactChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  id?: string;
}

export const InputPassword = ({
  dataCy,
  onChange,
  placeholder,
  id,
  ...rest
}: IInputPasswordProps) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleToggleVisibility = (event: ReactMouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setShowPassword((prev) => !prev);
  };

  return (
    <div className="input-field" style={{ display: 'flex', width: '100%' }} {...rest}>
      <input
        id={id}
        type={showPassword ? 'text' : 'password'}
        className="input-field"
        placeholder={placeholder}
        style={{
          all: 'unset',
          width: '100%',
        }}
        onChange={onChange}
        data-cy={dataCy}
      />
      <div style={{ display: 'flex', alignSelf: 'center' }}>
        <motion.button
          tabIndex={-1}
          key={showPassword ? 'visible' : 'hidden'}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          type="button"
          style={{ all: 'unset', display: 'flex', cursor: 'pointer' }}
          onClick={handleToggleVisibility}
          data-cy={`btn-toggle-${dataCy}-visibility`}
          aria-label={showPassword ? 'Hide password' : 'Show password'}
        >
          {showPassword ? <EyeIcon /> : <EyeOffIcon />}
        </motion.button>
      </div>
    </div>
  );
};
